import styled from 'styled-components';
import { useSettings } from '@wu/widget-core';
import { classnamePrefix } from '../../../constants';

export const Error = ({ text }) => {
  const { backgroundColor } = useSettings();

  return (
    text && (
      <Container _backgroundColor={backgroundColor}>
        <ErrorText dangerouslySetInnerHTML={{ __html: text }} />
      </Container>
    )
  );
};

const Container = styled.div.attrs({
  className: `${classnamePrefix}-error-container`
})`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 40px;
  box-sizing: border-box;
  background-color: ${({ _backgroundColor }) => _backgroundColor || '#fff'};
`;

const ErrorText = styled.div.attrs({
  className: `${classnamePrefix}-error-error`
})``;
